import React, { useState } from 'react';
import { useLayoutEffect } from 'react';

import { FaPlusCircle } from 'react-icons/fa';
import './SurgeryTypeSelection.css';
import './FormStyles.css';
import SideSelector from './SideSelector';
import AddSurgeryType from './AddSurgeryType';
import StepDrawer from './StepDrawer';
import { FaSearch } from 'react-icons/fa';

function SurgeryTypeSelection({
  onContinue,
  currentStep,
  totalSteps,
  onBack,
  onCancel,
  surgeryTypes,
  setSurgeryTypes,
  loading,
  error,
  formData,
  setFormData
}) {
  const [showSideSelector, setShowSideSelector] = useState(false);
  const [selectedSurgeryType, setSelectedSurgeryType] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState("");

  useLayoutEffect(() => {
    const el = document.querySelector('.App.scrollable');
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      console.warn('Element not found');
    }
  }, [])
  const toggleDescription = (index) => {
    surgeryTypes[index].showDescription = !surgeryTypes[index].showDescription
    setSurgeryTypes([...surgeryTypes])
  }

  const handleTypeSelect = (type, side) => {
    const isSelected = formData.procedures.some(t => t.name === type.name);
    let newSelectedTypes;

    if (isSelected) {
      newSelectedTypes = formData.procedures.filter(t => !(t.name === type.name));
      for (let i = 0; i < surgeryTypes.length; i++) {
        if (surgeryTypes[i].name == type.name && surgeryTypes[i].showDescription) {
          toggleDescription(i)
        }
      }
    } else {
      newSelectedTypes = [...formData.procedures, { ...type, side, showDescription: false }];
    }

    setFormData({ ...formData, procedures: newSelectedTypes })
  };

  const handleAddClick = (type) => {
    setSelectedSurgeryType(type);
    setShowSideSelector(true);
  };

  const handleSideSelect = (type, side) => {
    handleTypeSelect(type, side);
  };

  const handleContinue = () => {
    if (formData.procedures.length > 0) {
      onContinue();
    }
  };

  if (loading) {
    return <div className="loading">Loading surgery types...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <StepDrawer
      currentStep={currentStep}
      totalSteps={totalSteps}
      onCancel={onCancel}
      onContinue={handleContinue}
      title="Select Surgical Procedures"
      onBack={onBack}
      disabled={formData.procedures.length === 0 || formData.procedures.find(procedure => !procedure.side)}
    >
      <div className="form-content">
        {formData.procedures?.length <= 0 ? (
          <>
            <div style={{ fontSize: '0.9rem', fontWeight: '700' }}>Selected:</div>
            <p className="selection-hint" style={{ color: 'rgb(156, 163, 175)' }}>You have not selected any procedures yet.</p>
          </>
        ) : (
          <div className="surgery-list selected">
            <div style={{ fontSize: '0.9rem', fontWeight: '700' }}>Selected:</div>
            {formData.procedures.map((type, index) => {
              return (
                <div key={type.name} className="selected-surgeon-pill">
                  <span>
                    {`${type.side.charAt(0).toUpperCase() + type.side.slice(1)} ${type.name.charAt(0).toUpperCase() + type.name.slice(1)}`}
                  </span>
                  <button className="clear-selection" onClick={() => handleTypeSelect(type)}>
                    ×
                  </button>
                </div>
              )
            })}
          </div>
        )}
        <div className="search-input-container" style={{ marginTop: '1rem' }}>
          <FaSearch className="search-icon" />
          <input
            placeholder="Search..."
            className="search-input"
            style={{ paddingLeft: '36px', appearance: 'none' }}
            onChange={(e) => setSearchPhrase(e.target.value)}
          />
        </div>
        <div
          className="search-results"
          style={{ flex: 1, overflowY: 'auto', marginTop: '0px', border: 'none', boxShadow: 'none' }}
        >
          {surgeryTypes.filter(type => type.name.toLowerCase().includes(searchPhrase.toLowerCase())).map((type, i) => {
            const isSelected = formData.procedures.some(t => t.name === type.name);

            return (
              <React.Fragment key={type.name}>
                {!isSelected && (
                  <div className="line-item">
                    <div className="line-item-header">
                      <div className="doctor-name">
                        {type.name}
                      </div>
                      {type.showDescription ? (
                        <div style={{ color: 'rgb(156, 163, 175)' }}>{type.description}</div>
                      ) : (
                        <span onClick={(e) => toggleDescription(i)}
                          className="line-item-description-button">
                          Show description
                        </span>
                      )}
                    </div>
                    <div
                      className="line-item-button"
                      onClick={() => handleAddClick(type)}
                    >
                      Click To Select
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        <SideSelector
          isOpen={showSideSelector}
          onClose={() => setShowSideSelector(false)}
          onSelect={handleSideSelect}
          surgeryType={selectedSurgeryType}
        />

        <AddSurgeryType
          isOpen={showAddForm}
          onClose={() => setShowAddForm(false)}
          onAddSurgeryType={(newType) => {
            setSurgeryTypes(prev => [...prev, newType])
            setSelectedSurgeryType(newType);
            setShowSideSelector(true);
          }}
        />

        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ color: 'rgb(156, 163, 175)' }}>Don't see your procedure listed?</span>
            <button
              className="add-new-button"
              onClick={() => setShowAddForm(true)}
              style={{
                marginTop: '0px',
                background: 'none',
                border: 'none',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              <FaPlusCircle size={16} style={{ color: '#3498db' }} />
              <span style={{ color: '#3498db' }}>Add it to our database</span>
            </button>
          </div>
        </div>
      </div>
    </StepDrawer>
  );
}

export default SurgeryTypeSelection; 